import React, { Component } from "react"
import PropTypes from "prop-types"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import { connect } from "react-redux"

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes/"
import AppRoute from "./routes/route"

// layouts
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"
import "react-toastify/dist/ReactToastify.css"
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css"

import NotFoundPage from "pages/NotFoundPage"
// import { socketIO } from "socket"

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: "",
    }
    // this.state = {
    // }
    this.getLayout = this.getLayout.bind(this)
  }

  /**
   * Returns the layout
   */
  getLayout = () => {
    let layoutCls = VerticalLayout

    switch (this.props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }
  // componentDidMount() {
  //   // socketIO.open()
  //   // socketIO.emit("load settings")
  //   // socketIO.on("settings is here", (data) => {
  //   //   console.log(data, "socket connected 1")
  //   //   this.setState({
  //   //     data: data,
  //   //   })
  //   // })
  //   socketIO.on("GetBarData", (data) => {
  //     console.log(data, "socket connected 1")
  //     this.setState({
  //       data: data,
  //     })
  //   })
  // }

  render() {
    const Layout = this.getLayout()
    // console.log(this.state.data, "socket connected")
    // console.log(socketIO, "data")
    return (
      <React.Fragment>
        <Router>
          <Switch>
            {publicRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={NonAuthLayout}
                component={route.component}
                key={idx}
                isAuthProtected={false}
                {...route}
              />
            ))}

            {authProtectedRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={Layout}
                component={route.component}
                key={idx}
                isAuthProtected={true}
                exact
                {...route}
              />
            ))}

            <Route path="*" exact component={NotFoundPage} />
          </Switch>
        </Router>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  }
}

App.propTypes = {
  layout: PropTypes.object,
}

export default connect(mapStateToProps, null)(App)
